import { Helmet } from 'react-helmet'
import './App.css'
import BuildChampionGraph from './features/champion-graph/BuildChampionGraph'
import GithubButton from './components/buttons/GithubButton'
import KofiButton from './components/buttons/KofiButton'
import EmailButton from './components/buttons/EmailButton'
import DiscordButton from './components/buttons/DiscordButton'
import LogoHeader from './components/header/LogoHeader'
import SubtitleHeader from './components/header/SubtitleHeader'
import { LanguageProvider, useLanguage } from './i18n/LanguageContext'

function AppContent() {
  const { lang, toggleLang, t, theme, toggleTheme } = useLanguage()

  return (
    <div>
      <Helmet>
        <title>TFT Double Up Tracker</title>
        <meta name="description" content={t('meta.description')} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <script type="application/ld+json">
          {`
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "TFT Double Up Tracker",
        "url": "https://tftdoubleup.com"
      }
    `}
        </script>
      </Helmet>

      <div className="app-container">
        <header className="app-header">
          <div className="top-toggles">
            <button
              className="lang-toggle"
              onClick={toggleLang}
              aria-label="Toggle language"
            >
              {lang === 'en' ? 'EN' : 'ES'}
            </button>
            <button
              className="theme-toggle"
              onClick={toggleTheme}
              aria-label="Toggle theme"
            >
              {theme === 'dark' ? '☀' : '☽'}
            </button>
          </div>
          <LogoHeader />
          <h1>Double Up</h1>
          <SubtitleHeader />
          <div className="support-buttons">
            <GithubButton>Github Button</GithubButton>
            <KofiButton>Kofi Button</KofiButton>
            <DiscordButton>Discord Button</DiscordButton>
            <EmailButton>Email Button</EmailButton>
          </div>
        </header>

        <BuildChampionGraph />

        <footer className="app-footer">
          <p className="disclaimer">{t('disclaimer')}</p>
        </footer>
      </div>
    </div>
  )
}

function App() {
  return (
    <LanguageProvider>
      <AppContent />
    </LanguageProvider>
  )
}

export default App
